import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setSkipModalData } from "../../redux/onboardingReducer";
import { getOnboardingDetails, onboardingQuestions, setDataForStates, setOnboardingData } from "../../shared/_services/common.services";
import Loader from "../Loader";
import AIChatBot from "./AIChatBot";


const QuestionFour = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [currentQuestion, setCurrentQuestion] = useState([]);
  const isFromUserQuestionnaire = location?.state?.fromUserQuestionnaire;
  const [showLoaderSix, setShowLoaderSix] = useState(false);
  const [otherInput, setOtherInput] = useState("");
  const BIG_PURCHASE_OPTION = "Buying something big (car, home, property, etc.)";
  const isBigPurchaseSelected = selectedOptions.includes(BIG_PURCHASE_OPTION);


  const checkAndFillDataForQuesSix = async () => {
    setShowLoaderSix(true)
    const questions = await onboardingQuestions("Anything coming up that might affect your money or taxes?");
    // #69: same crash class as QuestionSix — an API failure leaves `.data`
    // undefined, a malformed 200 body can leave it non-array-but-truthy, and
    // currentQuestion[0] is read unguarded elsewhere in this screen.
    setCurrentQuestion(Array.isArray(questions?.data) ? questions.data : []);
    if (questions.status === 200) {
      const getOnboardingDetailsData = await getOnboardingDetails(questions?.data[0]?._id);
      if (getOnboardingDetailsData.status === 200) {
        let onboardingData = null;
        if (Array.isArray(getOnboardingDetailsData?.data?.data)) {
          onboardingData = getOnboardingDetailsData?.data?.data[0];
        } else if (getOnboardingDetailsData?.data?.error) {
          onboardingData = [];
        }
        let temp = setDataForStates(questions.data[0], onboardingData, false);
        if (temp.selectedData.length > 0) {
          setSelectedOptions([...temp.selectedData]);
        }
        setOtherInput(getOnboardingDetailsData?.data?.data?.[0]?.others || "");
      }
    }
    setShowLoaderSix(false)
  }

  useEffect(() => {
    checkAndFillDataForQuesSix();
  }, []);

  const handleNextQuestion = async () => {
    setShowLoaderSix(true)
    let body = {};
    let currentUser = JSON.parse(localStorage.getItem('currentUser'));
    body.clientId = currentUser?.user?._id;
    body.questionId = currentQuestion[0]?._id;
    body.others = otherInput;
    let selectedData = selectedOptions.map((data) => ({
      "name": data,
      "value": ""
    }));
    body = { ...body, selectedOptions: selectedData };
    if (isFromUserQuestionnaire) {
      let updateResponse = await setOnboardingData(body);
      setShowLoaderSix(false)
      if (updateResponse.status === 201) {
        navigate('/questionnaire');
      }
    } else {
      if (selectedOptions.length > 0) {
        let data = await setOnboardingData(body);
        setShowLoaderSix(false)
        if (data.status === 201) {
          navigate('/q5');
        }
      } else {
        setShowLoaderSix(false)
        dispatch(setSkipModalData(true));
      }
    }
  };


  const toggleOption = (option) => {
    setSelectedOptions((prevSelectedOptions) => {
      const NOTHING_OPTION = "Nothing right now";
      
      // If clicking "Nothing right now"
      if (option === NOTHING_OPTION) {
        if (prevSelectedOptions.includes(NOTHING_OPTION)) {
          // Deselect "Nothing right now"
          return prevSelectedOptions.filter((item) => item !== NOTHING_OPTION);
        } else {
          // Select only "Nothing right now" and deselect all others
          setOtherInput(""); // Clear the other input when selecting "Nothing right now"
          return [NOTHING_OPTION];
        }
      } else {
        // If clicking any other option
        if (prevSelectedOptions.includes(option)) {
          // Deselect the clicked option
          return prevSelectedOptions.filter((item) => item !== option);
        } else {
          // Select the clicked option and deselect "Nothing right now" if it's selected
          const filtered = prevSelectedOptions.filter((item) => item !== NOTHING_OPTION);
          return [...filtered, option];
        }
      }
    });
  };


  return (
    <>
      {showLoaderSix ? (
        <Loader />
      ) : (
        <div className="question-set">
          <div className="onboaring-quesn justify-content-between d-flex place-items-center">
            <h2>
              <span>Q4</span> <div>Anything coming up that might affect your money or taxes?
                <br />
                <p>Optional — choose what applies.</p>
              </div>
            </h2>
            {!isFromUserQuestionnaire && (
              <button
                type="button"
                className="as-btn-secondary"
                onClick={() => { navigate('/dashboard') }}
              >
                Continue Later</button>)}
          </div>

          <div className="onboarding-label mb-4">Click all that apply</div>

          <div className="onb-multi-select">
            {currentQuestion[0]?.options?.map((option) => (
              <div
                key={option}
                className={`onb-multi-select-option ${option.replace(/[\s\/]+/g, '')} ${selectedOptions.includes(option) ? "if_selected" : ""}`} //eslint-disable-line
                onClick={() => toggleOption(option)}
              >
                <span>{option}</span>
              </div>
            ))}
          </div>
        </div>)}

      {!showLoaderSix && (
        <div className="onboarding-footer">
          {isBigPurchaseSelected && (
            <div className="common-other-textbox mt-3 mb-3">
              <div className="onboarding-label mb-0">
                What are you planning to buy, and about how much?
              </div>
              <textarea
                name="otherText"
                id="otherText"
                placeholder="e.g., car, ~$20k"
                value={otherInput}
                onChange={(e) => setOtherInput(e.target.value)}
                required
              />
            </div>
          )}

          <div className="onboarding-footer-btns">
            <div className="d-flex justify-content-between w-100">
              {isFromUserQuestionnaire ? (
                <>
                  <button
                    type="button"
                    className="as-btn-secondary"
                    onClick={() => {
                      navigate("/questionnaire")
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="as-btn-primary"
                    onClick={handleNextQuestion}
                  >
                    Update
                  </button>
                </>
              ) : (
                <>
                  <button
                    type="button"
                    className="as-btn-secondary"
                    onClick={() => navigate("/q3")}
                  >
                    ← Planning Support
                  </button>
                  <button
                    type="button"
                    className="as-btn-primary"
                    onClick={handleNextQuestion}
                  >
                    Money Snapshot (Debts) →
                  </button>
                </>
              )}
            </div>
            <AIChatBot
              questionName={currentQuestion[0]?.questionName}
              options={currentQuestion[0]?.options}
              firstMsg="Let’s discuss education funding. Are you planning for your children’s education, or perhaps continuing education for yourself?"
            />
          </div>
        </div>
      )}
    </>
  );
};

export default QuestionFour;
